import script from "./OpportunityVSGlobalCountryRisk.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunityVSGlobalCountryRisk.vue?vue&type=script&setup=true&lang=js"

import "./OpportunityVSGlobalCountryRisk.vue?vue&type=style&index=0&id=5f93c466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f93c466"]])

export default __exports__